import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";
import { delay, filter, map, switchMap } from "rxjs/operators";

import { AppserverInstallationCredentialsRepository } from "@e-forsyning/common/credentials";
import { RedirectService } from "@e-forsyning/common/router";
import { AktuelBrugersInstallationerObserver } from "@e-forsyning/common/installation";
import { MatomoConfigService } from "./matomo/matomo-config.service";
import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";
import { ForsyningIndstillingerRepository } from "@e-forsyning/common/forsyning-indstillinger";

import { AppInfo } from "./app-info/app-info.model";
import { AppInfoService } from "./app-info/app-info.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Title } from "@angular/platform-browser";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
    public erLoggetInd$: Observable<boolean>;
    public infos$: Observable<AppInfo[]>;

    constructor(
        private readonly credentials: AppserverInstallationCredentialsRepository,
        private readonly redirectService: RedirectService,
        private readonly appInfoService: AppInfoService,
        private router: Router,
        private titleService: Title,
        private route: ActivatedRoute,
        private aktuelBrugersInstallationerObserver: AktuelBrugersInstallationerObserver,
        private matomoConfigService: MatomoConfigService,
        private umbracoIndstillingerObserver: UmbracoIndstillingerObserver,
        private forsyningIndstillingerRepository: ForsyningIndstillingerRepository
    ) {}

    public ngOnInit(): void {
        this.erLoggetInd$ = this.credentials.valueChanges.pipe(
            delay(0) /* Lav fra Synkron til Asynkron for at undgå: ExpressionChangedAfterItHasBeenCheckedError */,
            map((credentials) => !!credentials.forsyningNodeId)
        );
        this.infos$ = this.appInfoService.getInfos().pipe(delay(0) /* Lav fra Synkron til Asynkron for at undgå: ExpressionChangedAfterItHasBeenCheckedError */);

        this.setPageTitle();

        // Update Matomo site ID from both UmbracoIndstillinger and ForsyningIndstillinger
        this.umbracoIndstillingerObserver.valueChanges.pipe(filter((settings) => !!settings?.matomoSiteId)).subscribe((settings) => {
            this.matomoConfigService.updateSiteId(parseInt(settings.matomoSiteId, 10));
        });
    }

    public setPageTitle() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => {
                    const child: ActivatedRoute | null = this.route.firstChild;
                    const documentid = this.router.url.split("/mine-dokumenter/").pop();
                    let title = child && child.snapshot.data["title"];
                    if (this.router.url.includes("/mine-dokumenter/") && documentid && title) {
                        return `${title} - ${documentid}`;
                    } else if (title) {
                        return title;
                    }
                })
            )
            .subscribe((title) => {
                if (title) {
                    this.titleService.setTitle(`${title} - E|Forsyning`);
                }
            });
    }

    public onInstallationerClick(): void {
        this.redirectService.redirectTilInstallationer();
    }

    public onCloseAppInfo(value: AppInfo): void {
        value.visible = false;
        this.appInfoService.onCloseAppInfo(value);
    }
}
